export const routes = {
    DEFAULT: '/',
    MORE: '/more',
    ALERTS: '/alerts',
} as const;
